import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@components/table';
import { Row, Col } from 'react-bootstrap';
import { DASHBOARD_COMPLETENESS_COLOURS } from '@awp/constants';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { IconCaretDownFill, IconCaretRightFill } from '@awp/components/awpIcons';
import DetailMeasureTimeTable from '@awp/components/dashboards/GraphView/DetailMeasureTimeTable';

const DetailTable = ({ idx, requestDTO, convertPecentage }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [sort, setSort] = useState([{ id: 'SensorPlacementName', desc: false }]);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const getConvertPecentage = (sensorPlacement, idx) => {
    let green =
      isValueEmpty(sensorPlacement.ExpectedObsCount) && isValueEmpty(sensorPlacement.RedCount)
        ? 0
        : (
            ((sensorPlacement.ExpectedObsCount - sensorPlacement.RedCount) / sensorPlacement.ExpectedObsCount) *
            100
          ).toFixed(2);
    let red = (100 - green).toFixed(2);
    let colors = [green, 0, red, 0];
    return colors[idx];
  };
  const cellComponentExp = ({ row }) => (
    // Use Cell to render an expander for each row.
    // We can use the getToggleRowExpandedProps prop-getter
    // to build the expander.
    <span {...row.getToggleRowExpandedProps()}>{row.isExpanded ? <IconCaretDownFill /> : <IconCaretRightFill />}</span>
  );
  const TableColumns = useMemo(
    () => [
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: cellComponentExp,
      },
      {
        Header: 'Sensor Placement',
        accessor: 'SensorPlacementName',
        className: 'col-1',
        //sortType: sortByNumericThenAlpha,
        // Cell: ({ row, value }) => {
        // 	let v = value;
        // 	if (row && row.original && !isValueEmpty(row.original.RelativeElevationMillimetres))
        // 		v= v+" ("+row.original.RelativeElevationMillimetres+")";
        // 	return v;
        // }
      },
      {
        Header: '',
        accessor: 'AvailableTime',
        className: 'col-1',
        //sortType: sortByNumericThenAlpha,
        Cell: ({ row, value }) => {
          if (!row.original) return '';
          return (
            <Row>
              <Col lg={5} md={5} style={{ paddingLeft: '0', paddingRight: '0', display: 'flex' }}>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{
                    backgroundColor: `${DASHBOARD_COMPLETENESS_COLOURS[0]}`,
                    marginRight: '0.4rem',
                    fontSize: '96%',
                  }}
                >
                  {getConvertPecentage(row.original, 0)}
                </button>
                <button
                  type="button"
                  className="btn btn-sm text-white"
                  style={{
                    backgroundColor: `${DASHBOARD_COMPLETENESS_COLOURS[2]}`,
                    marginRight: '0.4rem',
                    color: '#D2B208',
                    fontSize: '96%',
                  }}
                >
                  {getConvertPecentage(row.original, 2)}
                </button>
              </Col>
            </Row>
          );
        },
      },
    ],
    [isMedium],
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Find current values of search and filter

  useEffect(() => {
    if (!requestDTO) return;
    setData(requestDTO); //children function of interest
  }, [requestDTO]);

  const renderRowSubComponent = useCallback(({ row }) => {
    if (!row || !row.original) return;
    let spId = row.original.SensorPlacementId;
    //fetchObservations(row.original);
    //let sotList = getSensorObservationDTOList(spId);
    return (
      <Row>
        <Col>
          <DetailMeasureTimeTable
            idx={`tbl_detail_completeness_dt_${spId}`}
            sensorPlacement={row.original}
            mornType="completeness"
          />
        </Col>
      </Row>
    );
  }, []);
  return (
    <Table
      id={idx}
      columns={TableColumns}
      data={data}
      fetchData={() => {}}
      loading={loading}
      search={[]}
      filters={[]}
      dataTriggers={[]}
      sort={sort}
      setSort={setSort}
      renderRowSubComponent={renderRowSubComponent}
      defaultPageSize={5} //must be one of [5, 10, 25, 50, 100]
    />
  );
};
DetailTable.propTypes = {
  idx: PropTypes.string,
  //requestDTO:PropTypes.object
};
export default DetailTable;
